/* Recently viewed: ids are stored by product.js in localStorage ('kora:recent'); this renders them via the search section API. */
(() => {
  if (customElements.get('kora-recent')) return;
  class KoraRecent extends HTMLElement {
    connectedCallback() {
      let ids = [];
      try { ids = JSON.parse(localStorage.getItem('kora:recent') || '[]'); } catch (e) { /* ignore */ }
      const exclude = this.dataset.exclude;
      this.ids = ids.map(String).filter((id) => id !== exclude).slice(0, Number(this.dataset.limit) || 8);
      if (!this.ids.length || !this.dataset.url) return;
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { this.io.disconnect(); this.load(); }
      }, { rootMargin: '300px 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
    async load() {
      try {
        const u = new URL(this.dataset.url, location.origin);
        u.searchParams.set('section_id', this.dataset.sectionId);
        u.searchParams.set('type', 'product');
        u.searchParams.set('q', this.ids.map((id) => `id:${id}`).join(' OR '));
        const res = await fetch(u.toString());
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const source = doc.querySelector('.recent__inner');
        const inner = this.querySelector('.recent__inner');
        if (!source || !inner || !source.querySelector('.card')) return;
        const track = source.querySelector('[data-recent-track]');
        const items = Array.from(track.children).sort((a, b) => this.ids.indexOf(a.dataset.recentId) - this.ids.indexOf(b.dataset.recentId));
        items.forEach((i) => track.appendChild(i));
        inner.innerHTML = source.innerHTML;
        inner.hidden = false;
      } catch (e) { /* stay hidden */ }
    }
  }
  customElements.define('kora-recent', KoraRecent);
})();
